import { t } from '../../shared/i18n/index.js';

/** Canonical durations remain minutes (plans) and seconds (results). */
export const MAX_ROUTINE_MINUTES = 3660 * 24 * 60;
export const MAX_ROUTINE_SECONDS = MAX_ROUTINE_MINUTES * 60;
export const DURATION_UNITS = {minutes:1, hours:60, days:1440};
export function durationUnit(minutes) {
  return minutes && minutes % 1440 === 0 ? 'days' : minutes && minutes % 60 === 0 ? 'hours' : 'minutes';
}
/** "30 min", "1 hour", "2 days" in the current language. */
export function durationText(minutes) {
  const unit=durationUnit(minutes), value=Number((minutes / DURATION_UNITS[unit]).toFixed(2));
  return unit === 'minutes' ? t('sync.duration.minutes', { value }) : t(`sync.duration.${unit}`, { count: value });
}
